import { io } from "socket.io-client";
import { SOCKETIO_URL } from "../Configurations/Urls";

let socket = null;

export function getNotificationSocket() {
  return socket;
}

export function connectNotificationSocket({ token, organizationId, onNotification }) {
  if (!SOCKETIO_URL || !token || !organizationId) {
    return null;
  }

  disconnectNotificationSocket();

  socket = io(SOCKETIO_URL, {
    transports: ["websocket", "polling"],
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 8,
  });

  socket.on("connect", () => {
    socket.emit("subscribe", { organization_id: Number(organizationId) });
  });

  socket.on("notification", (payload) => {
    if (typeof onNotification === "function") {
      onNotification(payload);
    }
  });

  return socket;
}

export function disconnectNotificationSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}

export function resubscribeNotificationSocket(organizationId) {
  if (socket?.connected && organizationId) {
    socket.emit("subscribe", { organization_id: Number(organizationId) });
  }
}
